import { render, staticRenderFns } from "./BrickCircleBase.vue?vue&type=template&id=6edbe61e&scoped=true&"
import script from "./BrickCircleBase.vue?vue&type=script&lang=js&"
export * from "./BrickCircleBase.vue?vue&type=script&lang=js&"
import style0 from "../Style/brick-circle-base.scss?vue&type=style&index=0&id=6edbe61e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbe61e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edbe61e')) {
      api.createRecord('6edbe61e', component.options)
    } else {
      api.reload('6edbe61e', component.options)
    }
    module.hot.accept("./BrickCircleBase.vue?vue&type=template&id=6edbe61e&scoped=true&", function () {
      api.rerender('6edbe61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/BrickCircleBase.vue"
export default component.exports